import { Box, LinearProgress, Skeleton } from '@mui/material';
import walletCardSkeletonStyles from './WalletCardSkeleton.style';
import { WalletCardSkeletonProps } from './types';
import useProgressBar from './hooks/useProgressBar';

const WalletCardSkeleton = ({
  currencyImg = null,
  showProgressBar = false,
}: WalletCardSkeletonProps) => {
  const { progress } = useProgressBar({
    isShowingProgressBar: showProgressBar,
  });

  return (
    <Box className={walletCardSkeletonStyles.skeletonCard}>
      <Box className={walletCardSkeletonStyles.skeletonHeader}>
        <Box>
          <Skeleton variant="rectangular" />
          <Skeleton variant="rectangular" />
        </Box>

        {currencyImg || <Skeleton variant="circular" />}
      </Box>

      <Box className={walletCardSkeletonStyles.dataContainer}>
        <Box>
          <Skeleton variant="rectangular" />
          <Skeleton variant="rectangular" />
        </Box>

        <Box>
          <Skeleton variant="rectangular" />
          <Skeleton variant="rectangular" />
        </Box>
      </Box>

      {showProgressBar && (
        <LinearProgress variant="determinate" value={progress} />
      )}
    </Box>
  );
};

export default WalletCardSkeleton;
